import React from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import LoadingModal from '../../../reuseable-components/LoadingModal'
import { connect } from 'react-redux'
import { getMetadata, createProjectFilters } from '../reducers/manageProjects'
import { Alert, Button, ButtonGroup, Col, Row, Modal, FormGroup, Checkbox, /*InputGroup*/ } from 'react-bootstrap'
// import { Typeahead } from 'react-bootstrap-typeahead'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

class ExportProject extends React.Component {

  state = {
    show: false,
    selected: [],
    selectedClients: [],
    downloadingProjects: false,
    alert: false,
  }

  componentDidMount(){
    this.props.getMetadata()
  }

  handleExport = () => {
    const exportFields = this.state.selected

    if (!exportFields.length) {
      return this.setState({ alert: true })
    }

    const { filters, sort_by } = createProjectFilters(this.props)

    let my_projects

    if (this.props.myProjectsFilter) {
      my_projects = true
    }

    this.setState({ downloadingProjects: true, show: false, alert: false })
    axios({
      url: `${getServerURL()}export-projects/`,
      method: 'GET',
      params: {
        filters,
        sort_by,
        my_projects,
        export_fields: JSON.stringify(exportFields)
      },
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("token")
      },
      responseType: 'blob',
    })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      const date = new Date().toJSON().split("T")[0].split("-")
      const formattedDate = `${date[1]}-${date[2]}-${date[0]}`
      link.setAttribute('download', `${formattedDate}_projects.xlsx`)
      this.setState({ downloadingProjects: false })
      swal({
        title: "Your file is ready",
        text: "Click the button to download",
        icon: "success",
        button: 'Download'
      })
      .then(() => {
        this.setState({ downloadingProjects: false })
        document.body.appendChild(link)
        link.click()
      })
    })
    .catch(error => {
      const message = "There was an error downloading your file."
      handleErrorFetchingData(error, message)
    })
  }

  showModal = () => this.setState({ show: true })

  hideModal = () => this.setState({ show: false })

  handleSelect = (e) => {
    let selected = [ ...this.state.selected ]
    if (selected.includes(e.target.value)) {
      selected = selected.filter( selection => selection !== e.target.value )
    } else {
      selected.push(e.target.value)
    }
    this.setState({ selected })
  }

  handleSelectAll = (exportOptions) => this.setState({ selected: exportOptions })
  handleRemoveAll = () => this.setState({ selected: [] })

  handleSelectClient = (value) => this.setState({ selectedClients: value })

  render () {
    const { clientFilter, metadata } = this.props

    let exportOptions = [
      'Status',
      'Short ID',
      'Number',
      'Project Title',
      'Description',
      'Start Date',
      'Completion Date',
      'Project Leads',
      'Regulatory Related',
      'Analysts',
      'RDUID',
    ]

    let metadataList = []

    if (clientFilter.length) {
      clientFilter.forEach(client => {
        metadata.forEach(metadataItem => {
          if (metadataItem.client === client.url) {
            metadataList.push(metadataItem.name)
          }
        })
      })
    } else {
      metadataList = metadata.map(metadataItem => metadataItem.name)
    }

    exportOptions = [ ...exportOptions, ...new Set(metadataList) ]

    return (
      <div id="ExportProject">
        <Button onClick={ this.showModal }>Export to Excel</Button>
        <LoadingModal
          show={this.state.downloadingProjects}
          text="Downloading projects data to Excel. This may take a few moments."
        />
        <Modal
          show={ this.state.show }
          onHide={ this.hideModal }
        >
          <Modal.Header closeButton>
            <Modal.Title>Export Projects</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <center>
              <h4>Select clients:</h4>
              <InputGroup>
                <Typeahead
                  id="ClientsFilterTypeahead"
                  clearButton
                  multiple
                  labelKey={ client => `${client.name} ${client.short_code}` }
                  selected={ this.state.selectedClients }
                  options={ this.props.clients }
                  placeholder="Clients"
                  onChange={ this.handleSelectClient }
                  />
                <InputGroup.Button><Button>Select All</Button></InputGroup.Button>
              </InputGroup>
            </center> */}
            {this.props.fetchingMetadata ?
              <center>
                <img alt="loader" src={require("../../../static/images/spinner.gif")} />
              </center>
              :
              <div>
                <center>
                  <h3>
                    Select fields to export:
                  </h3>
                </center>
                <div>
                  <FormGroup>
                    <Row>
                      { exportOptions.map(option => {
                        return (
                          <Col xs={ 6 } sm={ 4 } md={ 4 } lg={ 4 } key={ option }>
                            <Checkbox
                              value={ option }
                              checked={ this.state.selected.includes(option) }
                              onChange={ this.handleSelect }>{ option }</Checkbox>
                          </Col>
                        )
                      }) }
                    </Row>
                    <br/>
                    { this.state.alert ?
                      <Alert bsStyle="danger" onDismiss={ () => this.setState({ alert: false }) }>
                        <h5>Please select at least one column.</h5>
                      </Alert>
                      :
                      null
                    }
                    <center>
                      <ButtonGroup id="selection-buttons">
                        <Button className="remove-all-btn" onClick={ this.handleRemoveAll }>Remove All</Button>
                        <Button className="select-all-btn" onClick={ () => this.handleSelectAll(exportOptions) }>Select All</Button>
                      </ButtonGroup>
                    </center>
                  </FormGroup>
                </div>
              </div>
            }

          </Modal.Body>
          {this.props.fetchingMetadata ?
            null
            :
            <Modal.Footer>
              <Button onClick={ this.hideModal }>Close</Button>
              <Button bsStyle="primary" onClick={ this.handleExport }>Export</Button>
            </Modal.Footer>
          }
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    clients: state.manageLogin.clients,
    metadata: state.manageProjects.metadata,
    fetchingMetadata: state.manageProjects.fetchingMetadata,
    clientFilter: state.manageProjectFilters.clients,
    projectLeadFilter: state.manageProjectFilters.projectLeads,
    analystFilter: state.manageProjectFilters.analysts,
    projectNameFilter: state.manageProjectFilters.projectName,
    projectRduidFilter: state.manageProjectFilters.projectRduids,
    statusFilter: state.manageProjectFilters.status,
    regulatoryRelatedFilter: state.manageProjectFilters.regulatoryRelated,
    metadataFilters: state.manageProjectFilters.metadataFilters,
    myProjectsFilter: state.manageProjectFilters.myProjectsFilter,
  }
}

export default connect(mapStateToProps, { getMetadata })(ExportProject);



// WEBPACK FOOTER //
// ./src/routes/projects/components/ExportProject.js